import * as styles from './FaqStrip.module.scss'
import Heading from '../Heading/Heading'

const Faq = ({ title, questions }) => {
  return (
    <div className={styles.faqContainer} data-testid="faq-test-id">
      <div className={styles.faqTitleBlock}>
        <Heading className={styles.faqTitle} data-testid="faq-title-test-id">
          {title}
        </Heading>
      </div>
      <div
        className={styles.faqQuestionsBlock}
        data-testid="faq-questions-block-test-id">
        {questions.map(
          ({ question, answer, infoLink, infoLinkText }, index) => (
            <div className={styles.faqQaBlock} key={index}>
              <Heading
                type="h3"
                className={styles.faqQuestions}
                data-testid="faq-question-test-id">
                {question}
              </Heading>
              <hr className={styles.faqDivider} />
              <div
                className={styles.faqAnswers}
                data-testid="faq-answer-test-id">
                <p>
                  {answer + ' '}
                  {infoLink && (
                    <a href={infoLink} rel="noreferrer" target="_blank">
                      {infoLinkText}
                    </a>
                  )}
                </p>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default Faq
